










import Vue from 'vue'

export default Vue.extend({
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 2
    },
    errors: {
      type: Array as () => string[],
      default: () => []
    }
  },
  computed: {
    hasError(): boolean {
      return this.errors.length > 0
    },
    inputListeners(): Record<string, Function | Function[]> {
      const vm = this
      const data = {
        ...this.$listeners,
        input(e: { target: { value: string } }) {
          const trim = e.target.value
          vm.$emit('input', trim)
        }
        // TODO: 要考慮
      }
      return data
    }
  }
})
